<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">ICT Tools</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/ict-tools">ICT Tools</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="online-anti-ragging ptb--100  verticaltab--1">
  <div class="container">
    <div class="row">
      <div class="col">
        <iframe src="https://drive.google.com/file/d/1agVnM8TlPAjZ2xbe_NxufVY9o5tHpzh_/preview" width="100%"
          height="700px" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</section>
